import script from "./AutoGenerateCaptionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AutoGenerateCaptionModal.vue?vue&type=script&setup=true&lang=js"

import "./AutoGenerateCaptionModal.vue?vue&type=style&index=0&id=00837959&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00837959"]])

export default __exports__